import { ActionType, ComponentType } from '../../enums';
import { formatDate } from '../hotelsUtils/hotelsUtils';

export interface CreateViewSearchResultsEventPayloadOptions {
  adults: number;
  availablePropertyCount: number;
  children: number;
  destinationDomesticType?: string | null;
  destinationName: string;
  destinationType: string;
  endDate: string | Date;
  infants: number;
  paymentType: string;
  searchCategory: string;
  searchTerm: string;
  startDate: string | Date;
  totalPropertyCount: number;
  viewMode: string;
}

export interface CreateViewSearchResultsEventPayloadReturn {
  event_data: {
    action: ActionType;
    available_property_count: number;
    component_type: ComponentType;
    destination_domestic_type?: string | null;
    destination_name: string;
    destination_type: string;
    end_date: string;
    payment_type: string;
    search_category: string;
    search_term: string;
    start_date: string;
    total_property_count: number;
    travellers_adult: number;
    travellers_children: number;
    travellers_infant: number;
    view_mode: string;
  };
}

export const createViewSearchResultsEventPayload = ({
  availablePropertyCount,
  destinationName,
  destinationType,
  destinationDomesticType,
  endDate,
  startDate,
  paymentType,
  searchCategory,
  searchTerm,
  totalPropertyCount,
  viewMode,
  adults,
  children,
  infants,
}: CreateViewSearchResultsEventPayloadOptions): CreateViewSearchResultsEventPayloadReturn => {
  return {
    event_data: {
      action: ActionType.VIEW,
      component_type: ComponentType.SEARCH_RESULTS,
      search_term: searchTerm,
      view_mode: viewMode,
      search_category: searchCategory,
      payment_type: paymentType,
      available_property_count: availablePropertyCount,
      total_property_count: totalPropertyCount,
      end_date: formatDate(endDate),
      start_date: formatDate(startDate),
      destination_name: destinationName,
      destination_type: destinationType,
      ...(destinationDomesticType && { destination_domestic_type: destinationDomesticType }),
      travellers_adult: adults,
      travellers_children: children,
      travellers_infant: infants,
    },
  };
};
